import { render } from "./Etapa.vue?vue&type=template&id=42c97ec6&scoped=true"
import script from "./Etapa.vue?vue&type=script&lang=js"
export * from "./Etapa.vue?vue&type=script&lang=js"

import "./Etapa.vue?vue&type=style&index=0&id=42c97ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c97ec6"]])

export default __exports__